import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { Button, Typography } from "@mui/material";
import Flex from "../../../../../components/Flex";
import { useReduceDisclosure } from "../../../../../hooks/use-reduce-disclosure";
import { useUserProfile } from "../../../../../queries/use-user-profile";
import UserProfile from "../../UserProfile";
import ChangePasswordDrawer from "./ChangePasswordDrawer";
import EditProfileDrawer from "./EditProfileDrawer";

const AdminProfile = () => {
  const { data: userProfile } = useUserProfile({});

  const [editProfileModalDisclosure, passwordModalDisclosure] =
    useReduceDisclosure(2);

  return (
    <Flex flexDirection={"column"} alignItems={"center"}>
      <EditProfileDrawer
        profileData={{
          ...(userProfile?.data ?? {}),
          phone: userProfile?.data?.phone ?? "",
        }}
        open={editProfileModalDisclosure.opened}
        handleCloseEditModal={editProfileModalDisclosure.close}
      />
      <ChangePasswordDrawer
        open={passwordModalDisclosure.opened}
        onClose={passwordModalDisclosure.close}
      />
      <Flex justifyContent={"space-between"} width={"100%"}>
        <Typography
          fontSize={"20px"}
          color={"primary.main"}
          fontWeight={"medium"}
        >
          Admin Profile
        </Typography>
        <Flex gap={"15px"}>
          <Button
            sx={{
              textDecoration: "underline",
              textTransform: "none", // Optional: prevents text from being transformed to uppercase
              "&:hover": {
                textDecoration: "underline", // Ensures underline persists on hover
              },
            }}
            onClick={passwordModalDisclosure.open}
          >
            Change Password
          </Button>

          <Button
            variant="outlined"
            onClick={editProfileModalDisclosure.open}
            startIcon={<ModeEditOutlineOutlinedIcon />}
            sx={{ textTransform: "none" }}
          >
            Edit Profile
          </Button>
        </Flex>
      </Flex>
      <UserProfile userProfile={userProfile?.data} />
    </Flex>
  );
};

export default AdminProfile;
